import cn from '@ui/utils/cn'
import Animated from 'react-native-reanimated'
import { TypographyProps } from './types'
import { sLeading, sTypography } from './styles'

export default function Typography({
  children,
  className,
  style = {},
  color,
  variant,
  ...props
}: TypographyProps) {
  const styles = [style]
  if (color) styles.push({ color })

  return (
    <Animated.Text
      style={styles}
      className={cn(
        sTypography({ variant }),
        sLeading(variant),
        'select-text',
        className
      )}
      {...props}
    >
      {children}
    </Animated.Text>
  )
}
